import { Select } from '@mantine/core'

import { TERMINATED_REASON_OPTIONS } from 'src/lib/terminatedReason.utils'

import { inlineSelectProps } from './inlineSelectStyles'

const TerminatedReasonOptions = ({
  selectedTerminatedReason,
  setSelectedTerminatedReason,
}) => {
  const terminatedReasonOptions = TERMINATED_REASON_OPTIONS

  return (
    <div className="flex flex-col gap-2 text-xs font-medium">      <Select
        {...inlineSelectProps}
        value={selectedTerminatedReason?.terminatedReason}
        onChange={(value) =>
          setSelectedTerminatedReason({ terminatedReason: value })
        }
        data={terminatedReasonOptions}
        placeholder="Select terminated reason"
        className="max-w-sm"
        searchable
      />
    </div>
  )
}

export default TerminatedReasonOptions
